const started = new Set();
function append(part, snippetId) {
  return new Promise(resolve => {
    const script = document.createElement('script');
    script.dataset.jlaCustom = snippetId;
    if (part.elementId) script.id = part.elementId;
    script.type = part.type === 'module' ? 'module' : 'text/javascript';
    for (const [key, value] of Object.entries(part.data || {})) if (/^data-[a-z0-9_-]{1,50}$/.test(key)) script.setAttribute(key, value);
    let url;
    if (part.src) {
      try { url = new URL(part.src); } catch (_) { resolve(false); return; }
      if (url.protocol !== 'https:' || url.username || url.password) { resolve(false); return; }
    }
    if (part.src || part.type === 'module') {
      const timer = setTimeout(() => resolve(false), 10000);
      const finish = ok => { clearTimeout(timer); resolve(ok); };
      script.onload = () => finish(true); script.onerror = () => finish(false);
    }
    if (part.src) {
      // An external dependency may take time; pages and other snippets continue independently.
      script.async = true;
      if (part.integrity) { script.integrity = part.integrity; script.crossOrigin = 'anonymous'; }
      script.src = url.href;
    } else script.textContent = part.code || '';
    document.head.appendChild(script);
    if (!part.src && part.type !== 'module') resolve(true);
  });
}
export function startCustomScripts(snippets = []) {
  // Existing JS cannot be undone safely. Each named snippet starts once per full page load;
  // edits and disabling apply on the next reload, avoiding duplicate widgets/listeners.
  for (const snippet of snippets.slice(0, 10)) {
    if (!snippet.id || started.has(snippet.id) || !Array.isArray(snippet.parts)) continue;
    started.add(snippet.id);
    (async () => { for (const part of snippet.parts.slice(0, 10)) if (!await append(part, snippet.id)) break; })().catch(() => {});
  }
}
